import { faqArticleBodySchema } from "@redotech/redo-model/faq/faq-body-schema";
import { faqElementSchema } from "@redotech/redo-model/faq/faq-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createArticle = {
  name: "createArticle" as const,
  input: z.object({
    elements: z.array(faqElementSchema).optional(),
    html: z.string().optional(),
    title: z.string(),
    faqCollection: z.string(),
    published: z.boolean(),
  }),
  output: zExt.coercedResult(
    z.object({
      // oldArticle is only here so this output can match the updateArticle output
      oldArticle: z.optional(faqArticleBodySchema),
      newArticle: faqArticleBodySchema,
    }),
  ),
};
